<div class="container-fluid">
	<div class="row">

        
        <app-conditions id="step7" [uid]="getUid()" [parentForm]="parentForm"
[disabled]="disabled"
 [conditions]="initial?.conditions"></app-conditions>




